import ClassNames from "classnames"
import React, { useState, useEffect, useMemo } from "react"
import { get, includes, size, reject } from "lodash"
import * as Formatter from "utils/Formatter"

import { Panel } from "./index"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import { NewsList, NewsModal } from "./newsList"
import { ROUTE_LIST, history } from "config/const"
import { Labels } from "components/atoms/input/input"
import { LoadStateType, pageLoadRegist } from "redux/ducks/PageLoad"
import uuid from "uuid"
import store from "redux/store"
import { checkIsSp } from "utils/util"
import { BaseSelect } from "components/atoms/input/select"
import { useSelector } from "react-redux"

type Props = {
  history?: history
}

export const NewsTopicsPanel = () => {
  const [result, setResult] = useState({})
  const [modalData, setModalData] = useState({})
  const [currentTab, changeTab] = useState(0)
  const [refreshFlag, setRefreshFlag] = useState(false)
  const [allNewsRefreshFlag, setAllNewsRefreshFlag] = useState(false)
  const loadResistId = useMemo(() => uuid(), [])
  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const onclick = (num: number) => {
    let obj: object
    switch (num) {
      case 0:
        obj = mkwTnw
        break
      case 1:
        obj = mkwDbs
        break
      case 2:
        obj = mkwWbs
        break
      default:
        obj = {}
        break
    }
    setModalData(obj)
  }

  const callApi = async () => {
    const newsData: APIResponse.Res | {} = await APIs.News.News({
      TopN: 1,
      WithDetail: true,
      DayCount: 10,
      TopNCategory: "MKW_TNW,MKW_DBS,MKW_WBS",
    })
    setResult(newsData)
    setRefreshFlag(false)
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  useEffect(() => {
    callApi()
  }, [])

  useEffect(() => {
    isPageLoading && callApi()
  }, [isPageLoading])

  useEffect(() => {
    if (!refreshFlag) return
    store.dispatch(pageLoadRegist(loadResistId, true))
    callApi()
  }, [refreshFlag])

  const mkwTnw: object = get(result, "MKW_TNW.0")
  const mkwDbs: object = get(result, "MKW_DBS.0")
  const mkwWbs: object = get(result, "MKW_WBS.0")
  const isWbs: boolean = includes(get(window.location, "hash"), "/top/summary")

  const tabList = [
    {
      id: 0,
      name: "今朝の注目ニュース",
      component: mkwTnw && (
        <>
          <div className="news-header">
            <div className="header-title">{get(mkwTnw, "Title")}</div>
            <div className="time-col">
              {Formatter.date(get(mkwTnw, "UpdTime"), "MM/DD:HH:mm")}
            </div>
          </div>
          <div className={ClassNames("news-contents", "contents-all")}>
            {get(mkwTnw, "Content")}
          </div>
          <div
            className="btn btn-primary btn-shaped btn-more"
            onClick={() => onclick(0)}
          >
            もっと見る
          </div>
          <span className="news-more-mask" />
        </>
      ),
    },
    {
      id: 1,
      name: "株式相場見通し",
      component: mkwDbs && (
        <>
          <div className="news-header">
            <div className="header-title">{get(mkwDbs, "Title")}</div>
            <div className="time-col">
              {Formatter.date(get(mkwDbs, "UpdTime"), "MM/DD:HH:mm")}
            </div>
          </div>
          <div className={ClassNames("news-contents", "contents-all")}>
            {get(mkwDbs, "Content")}
          </div>
          <div
            className="btn btn-primary btn-shaped btn-more"
            onClick={() => onclick(1)}
          >
            もっと見る
          </div>
          <span className="news-more-mask" />
        </>
      ),
    },
    {
      id: 2,
      name: "米株式市場概要",
      component: isWbs && mkwWbs && (
        <>
          <div className="news-header">
            <div className="header-title">{get(mkwWbs, "Title")}</div>
            <div className="time-col">
              {Formatter.date(get(mkwWbs, "UpdTime"), "MM/DD:HH:mm")}
            </div>
          </div>
          <div className={ClassNames("news-contents", "contents-all")}>
            {get(mkwWbs, "Content")}
          </div>
          <div
            className="btn btn-primary btn-shaped btn-more"
            onClick={() => onclick(2)}
          >
            もっと見る
          </div>
          <span className="news-more-mask" />
        </>
      ),
    },
    {
      id: 3,
      name: "全てのニュース",
      component: (
        <NewsList
          route={isWbs ? ROUTE_LIST.TOP_SUMMARY : ROUTE_LIST.DOMESTIC_SUMMARY}
          title="全てのニュース"
          effect={allNewsRefreshFlag}
          setEffect={setAllNewsRefreshFlag}
          hiddenRefresh={true}
        />
      ),
    },
  ]

  return (
    <div>
      <Panel
        title={isSp && "ニュース"}
        className="panel-news-topics"
        // refresh={() => {
        //   if (currentTab === tabList[3].id) {
        //     setAllNewsRefreshFlag(true)
        //   } else {
        //     setRefreshFlag(true)
        //   }
        // }}
        filter={
          !isSp ? (
            <Labels
              className="btn-segmented-control btn-thin liquid-control filter-control-item"
              labelList={isWbs ? tabList : reject(tabList, { id: 2 })}
              checked={currentTab}
              onChange={(id: number) => {
                changeTab(id)
                if (id !== tabList[3].id) {
                  setRefreshFlag(true)
                }
              }}
            />
          ) : (
            <BaseSelect
              option={isWbs ? tabList : reject(tabList, { id: 2 })}
              value={currentTab}
              onChange={(id: number) => {
                changeTab(id)
                if (id !== tabList[3].id) {
                  setRefreshFlag(true)
                }
              }}
            />
          )
        }
      >
        {tabList[currentTab].component}
      </Panel>
      <NewsModal
        show={!!size(modalData)}
        onHide={() => setModalData({})}
        data={modalData}
      />
    </div>
  )
}
